import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";

const clearAction = createAction("clear");

export interface FileListState {
  usePagination: boolean;
}

const initialState: FileListState = {
  usePagination: false,
};

const fileListSlice = createSlice({
  name: "fileList",
  initialState,
  reducers: {
    setFileListPaginationMode: (state, action: PayloadAction<boolean>) => {
      state.usePagination = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearAction, () => initialState);
  },
});

export const { setFileListPaginationMode } = fileListSlice.actions;
export default fileListSlice.reducer;
